// IntegrationFieldSupport.jsx
import React from "react";

const items = [
{
  title: "AI-Integrated Device Control",
  desc: "Smart control systems with machine learning",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9993 6.66675H9.99935C8.1584 6.66675 6.66602 8.15913 6.66602 10.0001V30.0001C6.66602 31.841 8.1584 33.3334 9.99935 33.3334H29.9993C31.8403 33.3334 33.3327 31.841 33.3327 30.0001V10.0001C33.3327 8.15913 31.8403 6.66675 29.9993 6.66675Z"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3333 15H16.6667C15.7462 15 15 15.7462 15 16.6667V23.3333C15 24.2538 15.7462 25 16.6667 25H23.3333C24.2538 25 25 24.2538 25 23.3333V16.6667C25 15.7462 24.2538 15 23.3333 15Z"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 3.33325V6.66659"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 33.3333V36.6666"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 25H6.66732"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 15H6.66732"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.334 25H36.6673"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.334 15H36.6673"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3.33325V6.66659"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 33.3333V36.6666"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

 {
  title: "RS-422 / RS-485 / RS-232 Fanout",
  desc: "Multi-protocol signal distribution solutions",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.3327 35V31.6667C27.8907 31.6667 27.4667 31.4911 27.1542 31.1785C26.8416 30.866 26.666 30.442 26.666 30V28.3333C26.666 27.4493 27.0172 26.6014 27.6423 25.9763C28.2674 25.3512 29.1153 25 29.9993 25H33.3327C34.2167 25 35.0646 25.3512 35.6897 25.9763C36.3148 26.6014 36.666 27.4493 36.666 28.3333V30C36.666 30.442 36.4904 30.866 36.1779 31.1785C35.8653 31.4911 35.4414 31.6667 34.9993 31.6667"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6673 25V10.8333C31.6673 9.28624 31.0527 7.80251 29.9588 6.70854C28.8648 5.61458 27.3811 5 25.834 5C24.2869 5 22.8032 5.61458 21.7092 6.70854C20.6152 7.80251 20.0007 9.28624 20.0007 10.8333V29.1667C20.0007 30.7138 19.3861 32.1975 18.2921 33.2915C17.1981 34.3854 15.7144 35 14.1673 35C12.6202 35 11.1365 34.3854 10.0425 33.2915C8.94857 32.1975 8.33398 30.7138 8.33398 29.1667V15"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.0007 35.0001V31.6667H28.334"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.33333H11.6667V5"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6673 8.33333C12.1093 8.33333 12.5333 8.50893 12.8458 8.82149C13.1584 9.13405 13.334 9.55797 13.334 10V11.6667C13.334 12.5507 12.9828 13.3986 12.3577 14.0237C11.7326 14.6488 10.8847 15 10.0007 15H6.66732C5.78326 15 4.93542 14.6488 4.31029 14.0237C3.68517 13.3986 3.33398 12.5507 3.33398 11.6667V10C3.33398 9.55797 3.50958 9.13405 3.82214 8.82149C4.1347 8.50893 4.55862 8.33333 5.00065 8.33333V5"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},
{
  title: "RS-422 / RS-485 / RS-232 Fanout",
  desc: "Multi-protocol signal distribution solutions",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.3327 35V31.6667C27.8907 31.6667 27.4667 31.4911 27.1542 31.1785C26.8416 30.866 26.666 30.442 26.666 30V28.3333C26.666 27.4493 27.0172 26.6014 27.6423 25.9763C28.2674 25.3512 29.1153 25 29.9993 25H33.3327C34.2167 25 35.0646 25.3512 35.6897 25.9763C36.3148 26.6014 36.666 27.4493 36.666 28.3333V30C36.666 30.442 36.4904 30.866 36.1779 31.1785C35.8653 31.4911 35.4414 31.6667 34.9993 31.6667"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6673 25V10.8333C31.6673 9.28624 31.0527 7.80251 29.9588 6.70854C28.8648 5.61458 27.3811 5 25.834 5C24.2869 5 22.8032 5.61458 21.7092 6.70854C20.6152 7.80251 20.0007 9.28624 20.0007 10.8333V29.1667C20.0007 30.7138 19.3861 32.1975 18.2921 33.2915C17.1981 34.3854 15.7144 35 14.1673 35C12.6202 35 11.1365 34.3854 10.0425 33.2915C8.94857 32.1975 8.33398 30.7138 8.33398 29.1667V15"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.0007 35.0001V31.6667H28.334"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.33333H11.6667V5"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6673 8.33333C12.1093 8.33333 12.5333 8.50893 12.8458 8.82149C13.1584 9.13405 13.334 9.55797 13.334 10V11.6667C13.334 12.5507 12.9828 13.3986 12.3577 14.0237C11.7326 14.6488 10.8847 15 10.0007 15H6.66732C5.78326 15 4.93542 14.6488 4.31029 14.0237C3.68517 13.3986 3.33398 12.5507 3.33398 11.6667V10C3.33398 9.55797 3.50958 9.13405 3.82214 8.82149C4.1347 8.50893 4.55862 8.33333 5.00065 8.33333V5"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

 {
  title: "Signal Conditioning & EMI/EMC",
  desc: "Defence-grade signal integrity and interference mitigation",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3327 21.6666C33.3327 29.9999 27.4993 34.1666 20.566 36.5833C20.203 36.7063 19.8086 36.7004 19.4493 36.5666C12.4993 34.1666 6.66602 29.9999 6.66602 21.6666V9.99994C6.66602 9.55791 6.84161 9.13399 7.15417 8.82142C7.46673 8.50886 7.89065 8.33327 8.33268 8.33327C11.666 8.33327 15.8327 6.33327 18.7327 3.79994C19.0858 3.49827 19.5349 3.33252 19.9993 3.33252C20.4638 3.33252 20.9129 3.49827 21.266 3.79994C24.1827 6.34994 28.3327 8.33327 31.666 8.33327C32.108 8.33327 32.532 8.50886 32.8445 8.82142C33.1571 9.13399 33.3327 9.55791 33.3327 9.99994V21.6666Z"
        stroke="white"
        strokeWidth="3.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

];

export default function Technicalsupport() {
  return (
    <section className="tech">
      <style>{`
        :root {
          --bg-0:#050505;
          --bg-1:#0b0b0b;
          --card:#0f0f0f;
          --border:rgba(255,255,255,.08);
          --text:#ffffff;
          --muted:rgba(255,255,255,.65);
          --accent:#ff8a00;
          --shadow:0 20px 40px rgba(0,0,0,.6);
        }

        * { box-sizing:border-box; }

        .tech {
          background: radial-gradient(1200px 400px at 50% -200px, #1a1a1a, var(--bg-0));
          padding: 3.5rem 1.25rem;
          color: var(--text);
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto;
            color:white;
        }

        .tech__wrap {
          max-width: 1150px;
          margin: 0 auto;
          text-align: center;
            color:white;
        }

        .tech__title {
          margin: 0;
          font-size: clamp(1.4rem, 2.5vw, 1.8rem);
          font-weight: 700;
          letter-spacing: -.02em;
          color:white;
        }

        .tech__sub {
          margin-top: .6rem;
          font-size: .9rem;
          color:white;
        }

        .tech__grid {
          margin-top: 2.5rem;
          display: grid;
          grid-template-columns: repeat(4, minmax(0,1fr));
          gap: 1.25rem;
        }

        .tech__card {
          background: linear-gradient(180deg, rgba(235, 229, 229, 0.03), rgba(240, 227, 227, 0.01));
          border: 1px solid var(--border);
          border-radius: 18px;
          padding: 1.6rem 1.25rem;
          box-shadow: var(--shadow);
          transition: transform .2s ease, border-color .2s ease;
        }

        .tech__card:hover {
          transform: translateY(-4px);
          border-color: rgba(255,138,0,.45);
        }

        .tech__icon {
          width: 48px;
          height: 48px;
          margin: 0 auto 1rem;
          border-radius: 14px;
          background: var(--accent);
          display: grid;
          place-items: center;
          font-size: 1.2rem;
          box-shadow: 0 12px 22px rgba(255,138,0,.35);
        }

        .tech__label {
          margin: 0;
          font-size: .9rem;
          font-weight: 700;
        }

        .tech__desc {
          margin-top: .5rem;
          font-size: .78rem;
          line-height: 1.45;
          color: var(--muted);
          color:white;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .tech__grid {
            grid-template-columns: repeat(2, minmax(0,1fr));
          }
        }

        @media (max-width: 520px) {
          .tech {
            padding: 2.5rem 1rem;
          }
          .tech__grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="tech__wrap">
        <h2 className="tech__title">Technical Capabilities</h2>
        <p className="tech__sub">
          Advanced solutions for modern defence electronics
        </p>

        <div className="tech__grid">
          {items.map((item) => (
            <article className="tech__card" key={item.title}>
              <div className="tech__icon">{item.icon}</div>
              <h3 className="tech__label">{item.title}</h3>
              <p className="tech__desc">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
